import { ASSET_PATHS } from "./assets";

export const TrustedBy = () => (
  // --- Blending Background Setup ---
  // 1. `relative isolate`: Creates a new stacking context. This is crucial for `-z-10` to work correctly
  //    without the background element hiding behind the entire page's background.
  // 2. `bg-[#0f072d]`: A base background color that matches the dark theme of the hero section.
  // 3. `overflow-hidden`: Prevents the blurred gradient from spilling outside the section's bounds.
  <section className="relative isolate overflow-hidden bg-[#0f072d] py-16 md:py-24">
    
    {/* This is the magic element for the fading background */}
    <div
      className="absolute inset-0 -z-10 bg-gradient-to-b from-transparent via-[#130236] to-transparent"
      aria-hidden="true"
    />
    <div
      className="absolute inset-x-0 top-1/2 -z-10 h-[500px] -translate-y-1/2 bg-gradient-radial from-purple-900/30 to-transparent blur-3xl"
      aria-hidden="true"
    />

    <div className="container mx-auto px-4">
      <h2 className="text-center text-3xl sm:text-4xl md:text-5xl text-white font-pixel mb-10 md:mb-16">
        TRUSTED BY
      </h2>
      <div className="flex flex-wrap justify-around items-center gap-x-6 gap-y-8 md:gap-x-8">
        {Array.from({ length: 8 }).map((_, i) => (
          // --- Interactive Logo Container ---
          <div
            key={`trusted-${i}`}
            // Responsive height for the logos
            className="h-10 sm:h-12 md:h-14 lg:h-16 flex items-center"
          >
            <img
              // --- Effects for better blending and interactivity ---
              // `grayscale` and `opacity-70`: Makes logos blend into the dark background initially.
              // `hover:grayscale-0` and `hover:opacity-100`: Brings them to full color and opacity on hover.
              // `transition-all duration-300`: Smooths the hover effect.
              className="max-h-full w-auto object-contain grayscale opacity-70 hover:grayscale-0 hover:opacity-100 transition-all duration-300 ease-in-out"
              src={ASSET_PATHS.trustedCorp(i + 1)}
              alt={`Trusted Corporation ${i + 1}`}
            />
          </div>
        ))}
      </div>
    </div>
  </section>
);